import React, { useEffect, useState } from 'react';

import { Typography, PageHeader } from 'antd';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory } from 'react-router';
import { useMedia } from 'react-use';

import { DealBase, dealBaseApi } from 'core/lib';
import DealBaseBuilder from 'core/lib/utils/builders/DealBaseBuilder';
import { Routes } from 'routes/routes';
import { useLoggedInUser } from 'utils/hooks';

import { DealBaseForm } from '../form';

const { Title } = Typography;

const DealBaseNew = () => {
  const { t } = useTranslation(['loaders', 'actions', 'dealbase', 'global']);
  const currentUser = useLoggedInUser();
  const [dealbase] = useState(
    new DealBaseBuilder()
      .createdBy(currentUser)
      .founder([{ fullname: '', jobTitle: '' }])
      .currency('EUR')
      .build()
  );
  const isMobile = useMedia('(max-width: 768px)');
  const history = useHistory();
  const [activeTabKey, setActiveTabKey] = useState<string>();

  const [postDealBase, { isLoading: isSaving, isSuccess: saveSuccess, data }] = dealBaseApi.usePostDealBaseMutation();

  const onSave = (dealbase: DealBase) => {
    return postDealBase(dealbase).unwrap();
  };

  useEffect(() => {
    if (saveSuccess) {
      history.push(generatePath(Routes.DEAL_BASE_DETAILS.path, { id: data }));
    }
  }, [saveSuccess, data, history]);

  const onCancel = () => {
    history.push(Routes.DEAL_BASE_LISTING.path);
  };

  return (
    dealbase && (
      <>
        <PageHeader
          title={
            <div className="flex sm:flex-row flex-col items-center gap-2">
              <Title
                className="ws-normal md:truncate w-full text-center"
                style={{ margin: 0 }}
                level={isMobile ? 4 : 3}
              >
                {t('dealbase:placeholders.createDeal')}
              </Title>
            </div>
          }
        />
        <DealBaseForm
          activeTabKey={activeTabKey}
          setActiveTabKey={setActiveTabKey}
          isSaving={isSaving}
          dealbase={dealbase}
          onSave={onSave}
          onCancel={onCancel}
          editMode
          isNew
        />
      </>
    )
  );
};

export default DealBaseNew;
